import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { get_all_plans } from '../../api/planAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_frequency_name, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable'

export default function PlanPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [plansData, setPlansData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchPlans()
  }, [])

  const fetchPlans = async () => {
    setLoading(true)
    const data = await get_all_plans()
    if (data?.status === 200) {
      setPlansData(data.data)
    }
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Name",
      accessor: "plan_name"
    },
    {
      header: "Frequency",
      accessor: "frequency",
      modifier: (data) => tidy_frequency_name(data)
    },
    {
      header: "Status",
      accessor: "is_published",
      modifier: (data) => (data ? "Published" : "Draft"),
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]


  return (
    <AdminLayout
      navSelected={"Plans & Materials"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Plans & Materials</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/plan/details?plan_id=new")
            }}
          >
            <MdAdd size={16} />
            New Plan
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
        </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={plansData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button className="hover:underline" onClick={() => navigate(`/admin/plan/details?plan_id=${row.id}`)}>
                    Edit
                  </button>
                </div>
              )
            }}
          />
          {/* {plansData.map((plan, index) => {
            if (!JSON.stringify(plan).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">

                  <h3>{plan.plan_name}</h3>
                  <h3 className='card-subtitle'>Every {tidy_frequency_name(plan.frequency)} • {plan?.is_published == 1 ? "Published" : "Draft"}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/plan/details?plan_id=" + plan.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
        </div>
      )}
    </AdminLayout>
  )
}
